class PopupPromo extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('.popup-promo');
    if (!this.popup) return;
    
    this.delay = parseInt(this.popup.dataset.delay || 5, 10) * 1000;
    this.testMode = this.popup.dataset.testMode === 'true';
    this.popupId = this.popup.id;
    this.closeBtn = this.popup.querySelector('.popup-promo__close');
    this.overlay = this.popup.querySelector('.popup-promo__overlay');
    
    this.closePopup = this.closePopup.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.openPopup = this.openPopup.bind(this);
    
    this.init();
  }

  init() {
    if (!this.testMode && sessionStorage.getItem(`popup_shown_${this.popupId}`)) {
      return;
    }

    if (this.closeBtn) this.closeBtn.addEventListener('click', this.closePopup);
    if (this.overlay) this.overlay.addEventListener('click', this.closePopup);
    document.addEventListener('keydown', this.onKeydown);
    
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId === this.dataset.sectionId) this.openPopup();
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId === this.dataset.sectionId) this.closePopup();
      });
    }

    if (document.readyState === 'complete') {
      setTimeout(this.openPopup, this.delay);
    } else {
      window.addEventListener('load', () => setTimeout(this.openPopup, this.delay));
    }
  }

  openPopup() {
    this.popup.removeAttribute('hidden');
    // small delay to ensure display:flex is painted before adding active state
    setTimeout(() => {
      this.popup.setAttribute('data-active', 'true');
      // Use iOS-safe scroll lock if available (defined in as-header.liquid),
      // otherwise fall back to the standard overflow:hidden approach
      if (typeof window.__asLockScroll === 'function') {
        window.__asLockScroll();
      } else if (document.body) {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
    }, 50);
    
    if (!this.testMode && !(window.Shopify && Shopify.designMode)) {
      sessionStorage.setItem(`popup_shown_${this.popupId}`, 'true');
    }

    setTimeout(() => {
      if (this.closeBtn) this.closeBtn.focus();
    }, 350);
  }

  closePopup() {
    this.popup.removeAttribute('data-active');
    // Use iOS-safe scroll unlock if available, otherwise restore overflow
    if (typeof window.__asUnlockScroll === 'function') {
      window.__asUnlockScroll();
    } else if (document.body) {
      document.body.style.overflow = this.bodyOverflow || '';
    }
    setTimeout(() => {
      this.popup.setAttribute('hidden', '');
    }, 300);
  }
  
  onKeydown(e) {
    if (e.key === 'Escape' && this.popup.getAttribute('data-active') === 'true') {
      this.closePopup();
    }
  }
}

if (!customElements.get('popup-promo')) {
  customElements.define('popup-promo', PopupPromo);
}
